import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function ChangePasswordPage() {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setSubmitting(true);
    try {
      await changePassword(newPassword);
      if (user?.role === 'ceo') navigate('/dashboard');
      else navigate(`/division/${user?.division_id}`);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#F7F5F2' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold" style={{ color: '#1B2A4A' }}>Change Your Password</h1>
          <p className="mt-1 text-sm" style={{ color: '#6B7280' }}>
            Welcome, {user?.name}. Please set a new password to continue.
          </p>
        </div>
        <form onSubmit={handleSubmit} data-testid="change-password-form" className="bg-white rounded-lg shadow-sm border p-6 space-y-5" style={{ borderColor: '#E5E1DC' }}>
          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#1B2A4A' }}>New Password</label>
            <input data-testid="new-password-input" type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required
              className="w-full px-3 py-2.5 rounded-md border text-sm focus:outline-none focus:ring-2" style={{ borderColor: '#E5E1DC' }}
              placeholder="Min 8 characters" />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1.5" style={{ color: '#1B2A4A' }}>Confirm Password</label>
            <input data-testid="confirm-password-input" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required
              className="w-full px-3 py-2.5 rounded-md border text-sm focus:outline-none focus:ring-2" style={{ borderColor: '#E5E1DC' }}
              placeholder="Re-enter password" />
          </div>
          {error && <div data-testid="change-password-error" className="text-sm py-2 px-3 rounded-md" style={{ backgroundColor: '#FEF2F2', color: '#D4726A' }}>{error}</div>}
          <button data-testid="change-password-submit-btn" type="submit" disabled={submitting}
            className="w-full py-2.5 rounded-md text-sm font-medium text-white disabled:opacity-50" style={{ backgroundColor: '#1B2A4A' }}>
            {submitting ? 'Setting password...' : 'Set Password & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
}
